import {createTheme} from '@mui/material'
import {Colors} from 'appearance'

const theme = createTheme({
    direction: 'rtl',
    status: {
        danger: Colors.ERROR_TEXT,
    },
    palette: {
        primary: {
            main: Colors.PRIMARY_COLOR,
            darker: '#053e85',
        },
        secondary: {
            main: Colors.SECONDARY_COLOR,
        },
    },
    typography: {
        fontFamily: `'Open Sans', sans-serif`,
    },
    components: {
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    left: 'inherit',
                    right: '1.75rem',
                    transformOrigin: 'right',
                },
            },
        },
    },
})

export default theme
